import { getAxiosInstance, requestConfig } from "../../http-common";
import { FieldMappingRequest } from "../../models/ai-auto-mapping/FieldMappingRequest";

const RESOURCE_NAME = "aifieldmappings";

const automap = (model: FieldMappingRequest) => {
    const http = getAxiosInstance();
    return http.post<Record<string, string>>(`${RESOURCE_NAME}`, model, requestConfig());
};

const isAiEnabled = () => {
    const http = getAxiosInstance();
    return http.get<boolean>(`${RESOURCE_NAME}`, requestConfig());
}

const FieldMappingsService = {
    automap,
    isAiEnabled
};
export default FieldMappingsService;
